module.exports = __webpack_public_path__ + "static/nick.796068e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/nick.jpg
// module id = 538
// module chunks = 95715928098905 264598414423048